import Box from '@mui/material/Box';
import Sidebar from './Sidebar';
import HoverTip from '../common/HoverTip';

/** Sticky sidebar + fluid main column. Sidebar becomes an off-canvas drawer under 920px. */
export default function AppLayout({ children }) {
  return (
    <>
      <Box sx={{ display: 'flex', minHeight: '100vh' }}>
        <Sidebar />
        <Box
          component="main"
          sx={{
            flex: 1,
            minWidth: 0,
            p: { xs: '18px 16px 60px', md: '26px 30px 70px' },
          }}
        >
          {children}
        </Box>
      </Box>
      <HoverTip />
    </>
  );
}
